import {CHARACTER_CATEGORIES} from "./CharacterCategories";

export const PASSWORD_REQUIREMENTS = [
  {
    evaluate: function(password) {
      return /[A-Z]/.test(password);
    },
    requirement: CHARACTER_CATEGORIES.UPPER_CASE_LETTER
  },
  {
    evaluate: function(password) {
      return /[a-z]/.test(password);
    },
    requirement: CHARACTER_CATEGORIES.LOWER_CASE_LETTER
  },
  {
    evaluate: function(password) {
      return /[0-9]/.test(password);
    },
    requirement: CHARACTER_CATEGORIES.NUMBER
  },
  {
    evaluate: function(password) {
      return /[^A-Za-z0-9]/.test(password);
    },
    requirement: CHARACTER_CATEGORIES.SPECIAL_CHARACTER
  },
  {
    evaluate: function(password) {
      return password.length >= 8;
    },
    requirement: CHARACTER_CATEGORIES.MINIMUM_LENGTH
  }
];